import React from 'react';

import { useItinerary } from '../Itinerary/Provider';
import { usePrime } from 'clientState/providers/PrimeProvider';
import useGetBuyPathDeal from 'clientState/hooks/useGetBuyPathDeal';
import Reprice from './Reprice';

export const RepriceWrapper = () => {
  const { isPrimeSite } = usePrime();

  const dealBuyPath = useGetBuyPathDeal();

  const { dealInfo } = useItinerary() || {};

  if (!isPrimeSite || !dealBuyPath || !dealInfo) {
    return null;
  }

  return <Reprice trend={dealInfo?.trend} dealBuyPath={dealBuyPath} />;
};

export default RepriceWrapper;
